import { createFileRoute } from "@tanstack/react-router";

import { ContactsPage } from "../../../areas/seller/contacts/ContactsPage";
import type { ContactsSearch } from "../../../areas/seller/contacts/search";

/** FE-08 «Contactos»: visitor contacts of the seller's published sites (BE-16). */
export const Route = createFileRoute("/app/_seller/contacts")({
  // Types the URL only; the lazy screen checks the values (parseContactsSearch), keeping the entry chunk lean.
  validateSearch: (search: Record<string, unknown>) => search as ContactsSearch,
  component: ContactsPage,
});
